export const getUser = (userdata) => ({
  type: "UserData",
  payload: userdata,
});

export const getOneUser = (userdata) => ({
  type: "OneUserData",
  payload: userdata,
});

export const getBlogData = (blogdata) => ({
  type: "BlogData",
  payload: blogdata,
});
